module.exports = __webpack_public_path__ + "img/8.9479794e.jpg";